import { createFileRoute } from '@tanstack/react-router'
import { UniversityScreen } from '@web/app/features/universidades'
import { Globe } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/admin/universities')({
  component: UniversityScreen,
  staticData: {
    metaRoute: {
      title: 'Universidades',
      order: 1,
      icon: Globe,
    },
  },
})